import {addGenericErrorToast} from '@albert-io/atomic';
import {getStudentQuery} from 'client/Classrooms/StudentDashboard/StudentDashboard.queries.js';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

export default function useGetStudent() {
  const isStudentLoading = useStudentDashboard((state) => state.studentEmail === null);
  const setStudent = useStudentDashboard((state) => state.setStudent);
  const setStudentEmail = useStudentDashboard((state) => state.setStudentEmail);

  function fetchStudent() {
    getStudentQuery()
      .getResourcePromise()
      .then((fetchedStudent) => {
        setStudent(fetchedStudent);
        setStudentEmail(fetchedStudent.getEmail());
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      });
  }

  return {fetchStudent, isStudentLoading};
}
